import { NodeModel, PasteCommandParams } from '../../types';
import { getClonableNodes, getGlobal, guid } from '../../utils';
import { BaseCommand } from '../base';
import pasteCommand from '../paste';

export const pasteHereCommand: BaseCommand<PasteCommandParams> = {
  ...pasteCommand,

  init(graph) {
    const { point, models } = getGlobal(graph).clipboard;
    const nodesToPaste = getClonableNodes(models) as NodeModel[];

    this.params = nodesToPaste.reduce(
      (acc: PasteCommandParams, model) => {
        const { x, y } = model;
        const id = guid();
        const offsetX = point.x - (x || 0);
        const offsetY = point.y - (y || 0);

        return {
          newIds: [...acc.newIds, id],
          models: [
            ...acc.models,
            {
              ...model,
              id,
              x: (x || 0) + offsetX,
              y: (y || 0) + offsetY,
            },
          ],
        };
      },
      {
        newIds: [],
        models: [],
      },
    );
  },

  shortcuts: [],
};

export default pasteHereCommand;
